import { CollectionViewer, DataSource } from "@angular/cdk/collections";
import { BehaviorSubject, Observable, of } from "rxjs";
import { JobService } from "../services/job.service";
import { Job } from "../../shared/models/job.interface";
import { settings } from "../../shared/constants/settings";
import { catchError, finalize } from "rxjs/operators";
import { JobFilter } from "../models/job.filter";

export class JobsDataSource implements DataSource<Job> {
  private jobsSubject = new BehaviorSubject<Job[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();

  constructor(private jobService: JobService) { }

  connect(collectionViewer: CollectionViewer): Observable<Job[]> {
    return this.jobsSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.jobsSubject.complete();
    this.loadingSubject.complete();
  }

  loadJobs(filter: JobFilter,
    sortColumn = 'projectName', sortDirection = 'asc', pageIndex = 0) {

    this.loadingSubject.next(true);

    this.jobService.getList(filter, sortColumn, sortDirection, pageIndex).pipe(
      catchError(() => of([])),
      finalize(() => this.loadingSubject.next(false))
    )
      .subscribe(lessons => this.jobsSubject.next(lessons));
  }
}
